export default __webpack_public_path__ + "static/media/mini-logobeta.c1879b5f.png";